import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'

@Injectable({
  providedIn: 'root'
})
export class SupportService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    _userCasses: any = [];

    getUserCasses(userId: any, page: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        this._userCasses = this.http.get(this.common.apiServiceURL + 'Support/getUserCasses?page=' + page + '&userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
        return this._userCasses
    }
    getSupportSeverity(): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Support/getSupportSeverity', {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }
    getCaseStatistics(userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Support/getCaseStatistics?userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getCaseBySFID(sfId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Support/getCaseBySFID?sfId=' + sfId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getCaseActivityHistory(sfId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Support/getCaseActivityHistory?sfId=' + sfId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })

    }


    getCaseAttachments(sfId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Support/getCaseAttachments?sfId=' + sfId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    deleteFollower(followerId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Support/deleteFollower?followerId=' + followerId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    addAttachment(attachments: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Support/sendCaseAttachments', attachments, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    addSupportFollowers(followersObj: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Support/addSupportFollowers', followersObj, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    addCaseActivityHistory(activityHistory: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Support/addCaseActivityHistory', activityHistory, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })

    }


    getVendorInformation(): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Support/getVendorInformation', {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })

    }

    getProductInformation(): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Support/getProductInformation', {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
    }

    submitSupportCase(caseObject: any, isSystemRequired: any, userId: any, severityLevelId: any, type: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        var qString = 'isSystemDown=' + isSystemRequired + '&ownerId=' + userId + '&type=' + type;
        if (severityLevelId != 0)
            qString = qString + '&severityLevelId=' + severityLevelId;
        return this.http.post(this.common.apiServiceURL + 'Support/addCase?' + qString, caseObject, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })

    }
}
